// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-header ion-toolbar {
  background: var(--ion-diffuseDark-secondary) !important;
}

ion-title {
  font-size: 14px;
}

ion-card.contentcard {
  min-height: 50vh;
  background: var(--ion-white-secondary) !important;
}
ion-card.contentcard ion-card {
  box-shadow: none;
  text-align: center;
}
ion-card.contentcard ion-card ion-icon[name=alert-circle-outline] {
  font-size: 5em;
}
ion-card.contentcard ion-rating {
  --star-color: var(--ion-color-calendar);
  --star-color-filled: var(--ion-color-warning);
}
ion-card.contentcard ion-card-header {
  background: var(--ion-color-medium) !important;
  --background: var(--ion-color-medium)!important ;
}
ion-card.contentcard ion-card-header ion-row ion-col {
  border: 1px dashed #d2d2d2;
}
ion-card.contentcard ion-card-content {
  margin: 0;
  padding: 0vw;
  box-shadow: none;
}
ion-card.contentcard ion-list .selected-food {
  width: 90vw;
  background: var(--ion-diffuseLight-secondary);
  padding: 0vw;
  margin: 0 auto;
  position: relative;
  transition: all 0.5s ease-in-out;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  contain: none;
  box-shadow: var(--shadow-md);
  border-radius: 10px;
  margin-top: 3vw;
}
ion-card.contentcard ion-list .selected-food .innercard {
  width: 90vw;
  background: transparent;
  position: relative;
  transition: all 0.3s ease-in-out;
  overflow: visible;
  contain: none;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: space-between;
  margin: 0;
}
ion-card.contentcard ion-list .selected-food .innercard .action-slot {
  position: absolute;
  left: 2vw;
  top: 2vw;
  overflow: visible;
  contain: none;
  z-index: 5;
  transition: all 0.3s ease-in-out;
  transform: scaleY(1);
}
ion-card.contentcard ion-list .selected-food .innercard .action-slot ion-chip.mainchip {
  background: var(--ion-more-primary);
  margin: 0;
  padding: 0vw 2vw;
  min-height: 3vw;
  backdrop-filter: blur(10px);
}
ion-card.contentcard ion-list .selected-food .innercard .action-slot ion-note {
  font-size: 12px;
  color: var(--ion-text-primary);
}
ion-card.contentcard ion-list .selected-food .innercard .imgcontainer {
  position: relative;
  width: 30vw;
  height: 30vw;
  aspect-ratio: 1/1;
  top: 0vw;
  left: 0vw;
  border-radius: 0px;
  z-index: 3;
  overflow: visible;
  contain: none;
  transition: all 0.3s ease-in-out, z-index 0.4s ease-in-out 0.4s;
  transform: scale(1) translate3d(0px, 0px, 0px);
}
ion-card.contentcard ion-list .selected-food .innercard .imgcontainer .imgwrapper {
  object-fit: cover;
  width: 100%;
  height: 100%;
  transform: scale(1);
  object-position: 0px 20vw;
  transition: all 0.3s ease-in-out 0.3s;
}
ion-card.contentcard ion-list .selected-food .innercard .imgcontainer .imgwrapper .menu-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  object-position: 0px 0px;
  transform-origin: 45% 20%;
  transition: all 0.3s ease-in-out 0.5s;
  transform: scale(1);
}
ion-card.contentcard ion-list .selected-food .innercard .bottom {
  position: relative;
  display: flex;
  height: 30vw;
  width: 60vw;
  border-radius: 0;
  z-index: 2;
  overflow: visible;
  flex-direction: column;
  justify-content: center;
  top: 0vw;
  gap: 0vw;
  align-items: center;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1) 0.3s;
}
ion-card.contentcard ion-list .selected-food .innercard .bottom .content {
  display: flex;
  align-items: flex-start;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  gap: 0vw;
  padding: 1vw;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
ion-card.contentcard ion-list .selected-food .innercard .bottom .content .menuname {
  font-size: 14px;
  height: 10vw;
  overflow: auto;
  color: var(--ion-dark-primary);
  border-radius: 0px;
  font-weight: 400;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
ion-card.contentcard ion-list .selected-food .innercard .bottom .content .menudescription {
  display: block;
  font-size: 0px;
  height: 0;
  width: 0;
  color: var(--ion-dark-primary);
  border-radius: 0px;
  font-weight: 400;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
ion-card.contentcard ion-list .selected-food .innercard .bottom .ratingBox {
  margin: 1vw;
  --star-color:var(--ion-dark-primary);
  color: var(--ion-dark-primary);
  --star-color-filled: var(--ion-color-warning);
}
ion-card.contentcard ion-list .selected-food .innercard .bottom .ratingBox .comment {
  font-size: 10px;
}
ion-card.contentcard ion-list .selected-food .innercard .bottom macros-bar {
  margin: 0;
}
ion-card.contentcard ion-list .selected-food .innercard .bottom .macrowrap {
  display: flex;
  align-items: center;
  justify-content: space-between;
  opacity: 1;
  height: 5vw;
  width: 60vw;
  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}
ion-card.contentcard ion-list .selected-food .innercard .bottom .macrowrap .macrolist {
  display: flex;
  flex-direction: row;
  transition: all 0.3s var(--ease-elastic-3);
  justify-content: center;
  z-index: 5;
  height: 4vw;
  gap: 1vw;
  align-items: center;
  width: 60vw;
}
ion-card.contentcard ion-list .selected-food .innercard .bottom .macrowrap .macrolist .macro {
  transition: all 0.5s var(--ease-elastic-3);
  will-change: contents;
  display: flex;
  gap: 2px;
  width: 15%;
  align-items: center;
  flex-direction: row;
  border: 0px solid var(--prot) !important;
}
ion-card.contentcard ion-list .selected-food .innercard .bottom .macrowrap .macrolist .kcal {
  width: 25% !important;
}
ion-card.contentcard ion-list .selected-food .innercard .bottom .macrowrap .macrolist .kcal .macroval {
  border-left: none;
  border-right: none;
}
ion-card.contentcard ion-list .selected-food .innercard .bottom .macrowrap .macrolist .kcal .macroname {
  color: var(--ion-dark-primary);
  background: transparent;
}
ion-card.contentcard ion-list .selected-food .innercard .bottom .macrowrap .macrolist .macrop .macroval {
  border-left: none;
  border-right: none;
}
ion-card.contentcard ion-list .selected-food .innercard .bottom .macrowrap .macrolist .macrop .macroname {
  color: var(--ion-dark-primary);
  background: transparent;
}
ion-card.contentcard ion-list .selected-food .innercard .bottom .macrowrap .macrolist .macroc .macroval {
  border-left: none;
  border-right: none;
}
ion-card.contentcard ion-list .selected-food .innercard .bottom .macrowrap .macrolist .macroc .macroname {
  color: var(--ion-dark-primary);
  background: transparent;
}
ion-card.contentcard ion-list .selected-food .innercard .bottom .macrowrap .macrolist .macrof .macroval {
  border-left: none;
  border-right: none;
}
ion-card.contentcard ion-list .selected-food .innercard .bottom .macrowrap .macrolist .macrof .macroname {
  color: var(--ion-dark-primary);
  background: transparent;
}
ion-card.contentcard ion-list .selected-food .innercard .bottom .macrowrap .macrolist .macroname {
  opacity: 1;
  font-size: 12px !important;
  position: relative;
  transform: rotateX(0deg) translateX(0px);
  font-weight: 400;
  padding: 0px 1vw 0 0;
  margin: 0;
  transition: all 0.5s var(--ease-elastic-3) 0.3s;
  align-items: center;
  justify-items: center;
  will-change: contents;
  display: flex;
}
ion-card.contentcard ion-list .selected-food .innercard .bottom .macrowrap .macrolist .macroval {
  font-size: 14px !important;
  font-weight: 400;
  margin: 0;
  display: flex;
  height: 100%;
  padding: 0;
  transition: all 0.3s var(--ease-elastic-3) 0.3s;
  border-radius: 0px;
  align-items: center;
  justify-items: center;
  color: var(--ion-dark-primary);
}
ion-card.contentcard ion-list .selected-food ion-button {
  height: 7vw;
  width: 7vw;
  --padding-end: 0;
  --padding-start: 0;
  background: var(--ion-diffuseDark-secondary);
  --background: transparent;
  position: relative;
  border: 1px solid var(--ion-clear-tertiary);
  border-radius: 10px;
  padding: 1vw;
  box-shadow: var(--shadow-md);
}

ion-footer ion-toolbar {
  margin-bottom: 0px;
  background: var(--ion-color-medium) !important;
  --background: var(--ion-color-medium)!important ;
}
ion-footer ion-toolbar ion-button {
  min-height: 40px;
  color: #fff;
  --color: #fff;
}

.textArea {
  font-size: 12px;
  color: var(--ion-dark-primary);
}

.ratingLabel {
  font-size: 14px;
  color: var(--ion-dark-primary);
}

.close-gen {
  max-height: 10vw;
  min-height: 6vw;
  display: flex;
  margin: 0vw auto 5vw;
  padding: 1vw 4vw;
  background: var(--ion-color-primary);
  --background: transparent;
  border-radius: 15px;
  align-items: center;
  justify-content: center;
  color: var(--ion-text-primary);
  width: 90%;
}

.mainForm {
  padding: 3vw 0vw 0vw 0vw;
  border-radius: 15px;
  margin: 0;
}
.mainForm ion-item {
  padding: 3vw;
}

.ratingBoxInner {
  margin: 1vw;
  display: flex;
  align-items: center;
  justify-content: center;
  --star-color:var(--ion-dark-primary);
  color: var(--ion-dark-primary);
  --star-color-filled: var(--ion-color-warning);
}
.ratingBoxInner .comment {
  font-size: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/calendar/rating/rating.page.scss"],"names":[],"mappings":"AAEI;EACE,uDAAA;AADN;;AAKA;EAEI,eAAA;AAHJ;;AAMA;EACE,gBAAA;EACA,iDAAA;AAHF;AAKI;EACI,gBAAA;EACA,kBAAA;AAHR;AAKQ;EACI,cAAA;AAHZ;AAoBgB;EACI,uCAAA;EACA,6CAAA;AAlBpB;AAsBY;EACI,8CAAA;EACZ,gDAAA;AApBJ;AAsBoB;EACI,0BAAA;AApBxB;AAyBY;EACE,SAAA;EACA,YAAA;EACA,gBAAA;AAvBd;AAiEE;EACE,WAAA;EAEA,6CAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,gCAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,4BAAA;EACA,mBAAA;EACA,eAAA;AAhEJ;AAiEA;EAEE,WAAA;EAEA,uBAAA;EACA,kBAAA;EACA,gCAAA;EACA,iBAAA;EACA,aAAA;EAEA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;AAlEF;AAoEE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,iBAAA;EACA,aAAA;EACA,UAAA;EACA,gCAAA;EACA,oBAAA;AAlEJ;AAqEO;EACH,mCAAA;EACA,SAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;AAnEJ;AAsEM;EACA,eAAA;EACA,8BAAA;AApEN;AA4EA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,iBAAA;EACA,aAAA;EACA,+DAAA;EACA,8CAAA;AA1EF;AA4EA;EACE,iBAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;EACA,yBAAA;EACA,qCAAA;AA1EF;AA6EC;EACC,WAAA;EACA,YAAA;EACA,iBAAA;EACA,wBAAA;EACA,yBAAA;EACA,qCAAA;EACA,mBAAA;AA3EF;AAiFA;EACE,kBAAA;EACA,aAAA;EAEA,YAAA;EACA,WAAA;EACA,gBAAA;EACA,UAAA;EACA,iBAAA;EACA,sBAAA;EACA,uBAAA;EACA,QAAA;EACA,QAAA;EACA,mBAAA;EACA,8DAAA;AAhFF;AAsFA;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EAEA,QAAA;EACA,YAAA;EACA,yDAAA;AArFF;AAuFA;EACI,eAAA;EACA,YAAA;EACA,cAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,yDAAA;EACA,aAAA;EAEA,mBAAA;EACA,uBAAA;EACA,WAAA;AAtFJ;AA0FA;EACE,cAAA;EACA,cAAA;EACA,SAAA;EACA,QAAA;EACA,8BAAA;EACA,kBAAA;EACA,gBAAA;EACA,yDAAA;AAxFF;AA4FA;EACE,WAAA;EAEE,oCAAA;EACA,8BAAA;EACA,6CAAA;AA3FJ;AA4FA;EACE,eAAA;AA1FF;AA6FE;EACE,SAAA;AA3FJ;AA6FA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,UAAA;EACA,WAAA;EACA,WAAA;EAEA,yDAAA;AA5FF;AA+FC;EACC,aAAA;EACA,mBAAA;EACA,0CAAA;EACA,uBAAA;EACA,UAAA;EACA,WAAA;EACA,QAAA;EACA,mBAAA;EACA,WAAA;AA7FF;AAgGC;EACC,0CAAA;EACA,qBAAA;EACA,aAAA;EACA,QAAA;EACA,UAAA;EACA,mBAAA;EACA,mBAAA;EACA,wCAAA;AA9FF;AAiGA;EACE,qBAAA;AA/FF;AAgGE;EAEE,iBAAA;EACJ,kBAAA;AA/FA;AAmGQ;EACE,8BAAA;EACA,uBAAA;AAjGV;AA4GQ;EAEE,iBAAA;EACV,kBAAA;AA3GA;AA6GQ;EACE,8BAAA;EACA,uBAAA;AA3GV;AAoHQ;EAEE,iBAAA;EACV,kBAAA;AAnHA;AAsHQ;EACE,8BAAA;EACA,uBAAA;AApHV;AA6HQ;EAEA,iBAAA;EACR,kBAAA;AA5HA;AA8HQ;EACE,8BAAA;EACA,uBAAA;AA5HV;AAgIM;EACE,UAAA;EACA,0BAAA;EACA,kBAAA;EACA,wCAAA;EACA,gBAAA;EACA,oBAAA;EACA,SAAA;EACA,+CAAA;EACA,mBAAA;EACA,qBAAA;EACA,qBAAA;EACA,aAAA;AA9HR;AAkIM;EACE,0BAAA;EACA,gBAAA;EACA,SAAA;EACA,aAAA;EACA,YAAA;EACA,UAAA;EACA,+CAAA;EACA,kBAAA;EACA,mBAAA;EACA,qBAAA;EACA,8BAAA;AAhIR;AAwIC;EACC,WAAA;EACA,UAAA;EACA,gBAAA;EACA,kBAAA;EACA,4CAAA;EACA,yBAAA;EACA,kBAAA;EACA,2CAAA;EACA,mBAAA;EACA,YAAA;EACA,4BAAA;AAtIF;;AA6IQ;EACI,kBAAA;EACA,8CAAA;EACA,gDAAA;AA1IZ;AA4IY;EACI,gBAAA;EACA,WAAA;EACA,aAAA;AA1IhB;;AA8IA;EACA,eAAA;EACA,8BAAA;AA3IA;;AA6IA;EACE,eAAA;EACA,8BAAA;AA1IF;;AA4IA;EACI,gBAAA;EACA,eAAA;EACA,aAAA;EAEA,oBAAA;EACA,gBAAA;EACA,oCAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,UAAA;AA1IJ;;AA4IA;EACE,wBAAA;EAEA,mBAAA;EACA,SAAA;AA1IF;AA2IE;EACE,YAAA;AAzIJ;;AA4IA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACE,oCAAA;EACA,8BAAA;EACA,6CAAA;AAzIJ;AA0IA;EACE,eAAA;AAxIF","sourcesContent":["\nion-header{\n    ion-toolbar{\n      background: var(--ion-diffuseDark-secondary) !important;\n    }\n}\n\nion-title {\n    \n    font-size: 14px;\n}\n\nion-card.contentcard {\n  min-height: 50vh;\n  background: var(--ion-white-secondary) !important;\n  // --background: var(--ion-white-primary) !important;\n    ion-card {\n        box-shadow: none;\n        text-align: center;\n\n        ion-icon[name=\"alert-circle-outline\"] {\n            font-size: 5em;\n        }\n    }\n\n    // ion-list {\n    //     ion-card {\n    //         margin: 0;\n    //         border: 1px solid #d2d2d2;\n    //         border-radius: 0;\n\n    //         ion-item {\n    //             background: var(--ion-diffuseDark-secondary);\n    //             ion-img {\n    //                 border-radius: 10px;\n    //                 transform: scale(1.2);\n    //             }\n\n                ion-rating {\n                    --star-color: var(--ion-color-calendar);\n                    --star-color-filled: var(--ion-color-warning);\n                }\n    //         }\n\n            ion-card-header {\n                background: var(--ion-color-medium)!important ;\n    --background: var(--ion-color-medium)!important ;\n                ion-row {\n                    ion-col {\n                        border: 1px dashed #d2d2d2;\n                    }\n                }\n            }\n\n            ion-card-content {\n              margin: 0;\n              padding: 0vw;\n              box-shadow: none;\n            }\n    //     }\n    // }\n    ion-list {\n\n        // ion-card {\n        //     margin: 0;\n        //     border: 1px solid #d2d2d2;\n        //     border-radius: 0;\n\n        //     ion-item {\n        //         ion-img {\n        //             border-radius: 10px;\n        //             transform: scale(1.2);\n        //         }\n\n\n\n        //         ion-label {\n        //             h3 {\n        //                 display: flex;\n        //                 align-items: center;\n        //                 justify-content: space-between;\n        //             }\n        //         }\n        //     }\n\n        //     ion-card-header {\n        //         ion-row {\n        //             ion-col {\n        //                 border: 1px dashed #d2d2d2;\n        //             }\n        //         }\n        //     }\n\n        //     ion-card-content {\n        //         padding-top: 0;\n        //     }\n        // }\n\n\n  .selected-food{\n    width: 90vw;\n    // height: 25vw;\n    background: var(--ion-diffuseLight-secondary);\n    padding: 0vw;\n    margin: 0 auto;\n    position: relative;\n    transition: all 0.5s ease-in-out;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    contain: none;\n    box-shadow: var(--shadow-md);\n    border-radius: 10px;\n    margin-top: 3vw;\n.innercard {\n  \n  width: 90vw;\n//   height: 25vw;\n  background: transparent;\n  position: relative;\n  transition: all 0.3s ease-in-out;\n  overflow: visible;\n  contain: none;\n\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  justify-content: space-between;\n  margin: 0;\n\n  .action-slot {\n    position: absolute;\n    left: 2vw;\n    top: 2vw;\n    overflow: visible;\n    contain: none;\n    z-index: 5;\n    transition: all 0.3s ease-in-out;\n    transform:scaleY(1);\n     \n    \n       ion-chip.mainchip {\n    background: var(--ion-more-primary);\n    margin: 0;\n    padding: 0vw 2vw;\n    min-height: 3vw;\n    backdrop-filter: blur(10px);\n      }\n\n      ion-note {\n      font-size: 12px;\n      color: var(--ion-text-primary);\n     \n      }\n  \n     \n      }\n  \n     \n.imgcontainer {\n  position: relative;\n  width: 30vw;\n  height: 30vw;\n  aspect-ratio: 1 / 1;\n  top: 0vw;\n  left: 0vw;\n  border-radius: 0px;\n  z-index: 3;\n  overflow: visible;\n  contain: none;\n  transition: all 0.3s ease-in-out, z-index 0.4s ease-in-out 0.4s;\n  transform: scale(1) translate3d(0px, 0px, 0px);\n\n.imgwrapper {\n  object-fit: cover;\n  width: 100%;\n  height: 100%;\n  transform: scale(1);\n  object-position: 0px 20vw;\n  transition: all 0.3s ease-in-out 0.3s;\n\n\n .menu-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  object-position: 0px 0px;\n  transform-origin: 45% 20%;\n  transition: all 0.3s ease-in-out 0.5s;\n  transform: scale(1);\n}\n\n}\n\n}\n.bottom {\n  position: relative;\n  display: flex;\n  // background: var(--ion-color-primary);\n  height: 30vw;\n  width: 60vw;\n  border-radius:0;\n  z-index: 2;\n  overflow: visible;\n  flex-direction: column;\n  justify-content: center;\n  top: 0vw;\n  gap: 0vw;\n  align-items: center;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1) 0.3s;\n\n\n\n  \n\n.content {\n  display: flex;\n  align-items: flex-start;\n  flex-direction: row;\n  justify-content: space-between;\n  width: 100%;\n  // height: 100%;\n  gap: 0vw;\n  padding: 1vw;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n\n.menuname {\n    font-size: 14px;\n    height: 10vw;\n    overflow: auto;\n    color: var(--ion-dark-primary);\n    border-radius: 0px;\n    font-weight: 400;\n    transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n    display: flex\n;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n\n}\n\n.menudescription {\n  display: block;\n  font-size: 0px;\n  height: 0;\n  width: 0;\n  color:var(--ion-dark-primary);\n  border-radius: 0px;\n  font-weight: 400;\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n\n}\n.ratingBox {\n  margin: 1vw;\n  // height: 5vw;\n    --star-color:var(--ion-dark-primary);\n    color:var(--ion-dark-primary);\n    --star-color-filled: var(--ion-color-warning);\n.comment{\n  font-size: 10px;\n}\n  }\n  macros-bar{\n    margin: 0;\n  }\n.macrowrap{\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  opacity: 1;\n  height: 5vw;\n  width: 60vw;\n  // background: var(--ion-diffuseDark-secondary);\n  transition: all 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n\n\n .macrolist {\n  display: flex;\n  flex-direction: row;\n  transition: all 0.3s var(--ease-elastic-3);\n  justify-content: center;\n  z-index: 5;\n  height: 4vw;\n  gap: 1vw;\n  align-items: center;\n  width: 60vw;\n\n\n .macro {\n  transition: all 0.5s var(--ease-elastic-3);\n  will-change: contents;\n  display: flex;\n  gap: 2px;\n  width: 15%;\n  align-items: center;\n  flex-direction: row;\n  border: 0px solid var(--prot) !important;\n\n}\n.kcal{\n  width: 25% !important;\n  .macroval{\n    // border: 1px solid var(--kcal);\n    border-left: none;\nborder-right: none;\n    }\n        \n\n        .macroname{\n          color: var(--ion-dark-primary);\n          background: transparent;\n        }\n   \n      }\n  \n      .macrop {\n        \n        // background: linear-gradient(0deg, var(--prot) 0%, var(--prot) 2%, rgba(255, 255, 255, 0) 5%, rgba(255, 255, 255, 0) 100%);\n        // background-position: right 4vw bottom 4vw;\n        // background-size: 200%;\n        // background-repeat: no-repeat;\n        .macroval{\n          // border: 1px solid var(--prot);\n          border-left: none;\nborder-right: none;\n          }\n        .macroname{\n          color: var(--ion-dark-primary);\n          background: transparent;\n        }\n      }\n  \n      .macroc {\n        // background: linear-gradient(0deg, var(--carb) 0%, var(--carb) 2%, var(--ion-dark-primary)0 5%, var(--ion-dark-primary)0 100%);\n        // background-position: right 4vw bottom 4vw;\n        // background-size: 200%;\n        // background-repeat: no-repeat;\n        .macroval{\n          // border: 1px solid var(--carb);\n          border-left: none;\nborder-right: none;\n          }\n\n        .macroname{\n          color: var(--ion-dark-primary);\n          background: transparent;\n        }\n      }\n  \n      .macrof {\n        // background: linear-gradient(0deg, var(--fat) 0%, var(--fat) 2%, var(--ion-dark-primary)0 5%, var(--ion-dark-primary)0 100%);\n        // background-position: right 4vw bottom 4vw;\n        // background-size: 200%;\n        // background-repeat: no-repeat;\n        .macroval{\n        // border: 1px solid var(--fat);\n        border-left: none;\nborder-right: none;\n        }\n        .macroname{\n          color: var(--ion-dark-primary);\n          background: transparent;\n        }\n      }\n\n      .macroname {\n        opacity: 1;\n        font-size: 12px !important;\n        position: relative;\n        transform: rotateX(0deg) translateX(0px);\n        font-weight: 400;\n        padding: 0px 1vw 0 0;\n        margin: 0;\n        transition: all 0.5s var(--ease-elastic-3) 0.3s;\n        align-items: center;\n        justify-items: center;\n        will-change: contents;\n        display: flex;\n        // border-right: 2px solid;\n      }\n  \n      .macroval {\n        font-size: 14px !important;\n        font-weight: 400;\n        margin: 0;\n        display: flex;\n        height: 100%;\n        padding: 0;\n        transition: all 0.3s var(--ease-elastic-3) 0.3s;\n        border-radius: 0px;\n        align-items: center;\n        justify-items: center;\n        color: var(--ion-dark-primary);\n      }\n  \n    }\n}\n\n}\n }\n ion-button{\n  height: 7vw;\n  width: 7vw;\n  --padding-end: 0;\n  --padding-start: 0;\n  background: var(--ion-diffuseDark-secondary);\n  --background: transparent;\n  position: relative;\n  border: 1px solid var(--ion-clear-tertiary);\n  border-radius: 10px;\n  padding: 1vw;\n  box-shadow: var(--shadow-md);\n }\n}\n  \n    }\n  }\n    ion-footer {\n        ion-toolbar {\n            margin-bottom: 0px;\n            background: var(--ion-color-medium)!important ;\n            --background: var(--ion-color-medium)!important ;\n    \n            ion-button {\n                min-height: 40px;\n                color: #fff;\n                --color: #fff;\n            }\n        }\n    }\n.textArea{\nfont-size: 12px;\ncolor: var(--ion-dark-primary);\n}\n.ratingLabel{\n  font-size: 14px;\n  color: var(--ion-dark-primary);\n}\n.close-gen{\n    max-height: 10vw;\n    min-height: 6vw;\n    display: flex\n;\n    margin: 0vw auto 5vw;\n    padding: 1vw 4vw;\n    background: var(--ion-color-primary);\n    --background: transparent;\n    border-radius: 15px;\n    align-items: center;\n    justify-content: center;\n    color: var(--ion-text-primary);\n    width: 90%;\n}\n.mainForm{\n  padding: 3vw 0vw 0vw 0vw;\n  // box-shadow:var(--shadow-m-anim);\n  border-radius: 15px;\n  margin: 0;\n  ion-item{\n    padding: 3vw;\n  }\n}\n.ratingBoxInner {\n  margin: 1vw;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n    --star-color:var(--ion-dark-primary);\n    color:var(--ion-dark-primary);\n    --star-color-filled: var(--ion-color-warning);\n.comment{\n  font-size: 10px;\n}\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
